/**
 *  All api related to points history
 */
import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchLoyaltyPointTransactions(options) {
  const { page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchLoyaltyPointTransactions',
    () => source.cancel('fetchLoyaltyPointTransactions: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'loyalty_point_transactions',
      method: 'get',
      params,
      arrayFormat: _.has(params, 'scopes') ? 'brackets' : 'comma',
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      loyaltyPointTransactions: data.loyaltyPointTransactions,
      pagination: data.loyaltyPointTransactionsPagination,
      next: _.get(data, 'loyaltyPointTransactionsPagination.nextPage') > page
        ? () => fetchLoyaltyPointTransactions({ page: page + 1, ...others })
        : null,
      count: _.get(data, 'loyaltyPointTransactionsPagination.totalCount')
    }))
}
